function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
   setTimeout(function(){ 
  let pop = getCookie("age_verification");
  if (pop != "") {
    $('.modalpage__dialog').hide();
    $(document).find('body').removeClass('over-flow');
  } else {
    $('.modalpage__dialog').show();
    $(document).find('body').addClass('over-flow');
  }
     checkCookie(); }, 1);
}
checkCookie();
$(document).ready(function($){
   $('.results .close').click(function(){
      $('.modalpage__dialog').hide();
      $(document).find('body').removeClass('over-flow');
       let pop   = "verification";
        setCookie("age_verification", pop, 1);
         checkCookie(); 
    }); 
  $('.clear .button').click(function(){
      $('.modalpage__dialog').hide();
      $(document).find('body').removeClass('over-flow');
        pop = "verification";
        setCookie("age_verification", pop, 1);
        checkCookie();
 });
});